export default ({...props}) => {
  const {unit, size, space, palette} = props.theme
  return `
    @media screen and (max-width: 335px) {
        & div[ap_atom_name="apModalHeaderAtom"] > p[ap_atom_name="typographyAtom"] {
            font-size: ${unit(18)}px;
        }
    }
    
    & > form {
        display: flex;
        flex-flow: column;
        margin-top: ${space(3.9375)}px;

        & > div.form-field-wrapper {
            display: flex;
            align-items: flex-start;
            gap: ${space(1)}px;

            & > div.checkbox-wrapper {
                position: relative;
                top: ${space(1.25)}px;
            }

            & > div.input-wrapper {
                flex-grow: 1;
            }

            & > div.phone-input-field-wrapper {
                display: inline-flex;
                gap: ${space(1)}px;

                & > div.cc-input-field-wrapper {
                    width: ${unit(20)}%;

                    @media screen and (max-width: 376px) {
                        width: ${unit(30)}%;
                        & input {
                            padding: ${space(2.0625)}px ${space(
    1.75,
  )}px !important;
                        }
                    }

                    @media screen and (max-width: 350px) {
                        width: ${unit(40)}%;
                    }
                }

                & > div.number-input-field-wrapper {
                    flex-grow: 1;
                }
            }

            & div.MuiTextField-root {
                & .MuiInputLabel-shrink{
                    margin-left: 0;
                    transform: translate(${space(1.75)}px, -${space(
    1.125,
  )}px) scale(0.75);
                }

                & div.MuiInputBase-colorPrimary.MuiInputBase-formControl {
                    border-radius: ${space(0.5)}px;
                    background-color: ${palette.common.white};

                    & input {
                        padding: ${space(2.0625)}px ${space(1.75)}px;
                    }
                }
            }

            & p.MuiTypography-root[ap_atom_name="typographyAtom"] {
                height: ${size(2)}px;
                padding-left: ${space(1)}px;
            }
        }
        
        & > div.MuiBox-root.button-wrapper{
            display: flex;
            margin-top: ${space(4)}px;
            gap: ${space(3)}px;
    
            @media screen and (max-width:321px){
                flex-flow: column;
            }
    
            & button {
                text-transform: capitalize;
            }
        }
    } 
    `
}
